// input: https://api-sandbox.glynt.ai/v6/data-pools/hIjeG1/training-sets/VtLDt1/?advanced=true
// output: VtLDt1
export const getIdFromUrl = (url) => {
  // check possible null url
  if (url) {
    const temp = url.split('/');
    return temp[temp.length - 2];
  } else {
    return '';
  }
};
